import { SUCCESS_SUFFIX, FAILURE_SUFFIX } from 'core/actions/apis';

const rootActionPath = 'core/EarnStores';

export const EARN_STORES_GET_SUCCESS = `${rootActionPath}/GET_${SUCCESS_SUFFIX}`;
export const EARN_STORES_GET_FAILURE = `${rootActionPath}/GET_${FAILURE_SUFFIX}`;
